import makeStyles from '@mui/styles/makeStyles'

const useSolarMapViewStyles = makeStyles({
  root: {
    '& .MuiPickersDay-daySelected': {
      backgroundColor: 'transparent !important', // Remove white background
      boxShadow: 'none',
      borderRadius: '50px',
      border: 'none',
      '&:hover': {
        backgroundColor: 'transparent !important',
        border: 'none',
      },
    },
    '& .MuiInputBase-root': {
      color: '#000',
      backgroundColor: 'transparent !important', // Ensure transparency
      borderRadius: '50px',
      border: 'none',
    },
  },
  datePicker: {
    color: '#000',
    backgroundColor: 'transparent !important', // Remove white background
    border: 'none',
    boxShadow: 'none',

    '& .MuiOutlinedInput-root': {
      border: 'none',
      height: '48px',
      width: '200px',
      backgroundColor: 'transparent !important', // Ensure input field is transparent
    },
    '& .MuiOutlinedInput-input': {
      border: 'none',
      padding: '10px',
      backgroundColor: 'transparent !important', // Ensure no white square
    },
  },
})

export default useSolarMapViewStyles
